import type { PriorityCardExpiry } from '@/components/teacher-request/PriorityRequestCard'

export function getExpiryText(expiresAt: string | null): PriorityCardExpiry | null {
  if (!expiresAt) return null
  const expiry = new Date(expiresAt)
  const now = new Date()
  const diffMs = expiry.getTime() - now.getTime()

  if (diffMs <= 0) return { text: 'Abgelaufen', color: 'text-gray-500' }

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
  const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

  if (diffHours < 2) return { text: `Läuft in ${diffMinutes}m ab`, color: 'text-red-600 font-medium' }
  if (diffHours < 24) return { text: `Läuft in ${diffHours}h ${diffMinutes}m ab`, color: 'text-orange-600' }
  return { text: `Läuft in ${diffHours}h ab`, color: 'text-green-600' }
}
